<div class="footer-container">
  <footer class="footer">
    <div class="footer__company">
      <p> GMV © {{ year }}</p>
    </div>
  </footer> 
</div>
